__turbopack_context__.v({
  "inputButton": "multiSearchInput-module-scss-module__0oYtVq__inputButton",
  "inputLabel": "multiSearchInput-module-scss-module__0oYtVq__inputLabel",
});
